module.exports = __webpack_public_path__ + "img/logo-01.130a5a14.png";